import { DateType, Team, User } from '../models';

export enum ApprovalStatus {
  ApprovalRequested = 'APPROVAL_REQUESTED',
  ChangeRequested = 'CHANGE_REQUESTED',
  Approved = 'APPROVED',
}

/** At least one of `userId` or `teamId` is always present at runtime (enforced by the backend). */
export interface ApprovalRequestTo {
  userId?: number;
  teamId?: number;
  approvalStatus: ApprovalStatus;
  user?: User;
  team?: Team;
  updatedAt?: number;
  updateAt?: number;
}

export interface ApprovalComment {
  commentId: number;
  content?: string | null;
  createdBy: number;
  createdAt: number;
  private: boolean;
}
export enum ApprovalObjectType {
  Document = 'DOCUMENT',
  Task = 'TASK',
}

export interface Approval {
  approvalId: number;
  dueDate?: DateType | null;
  requestBy: User;
  requestTo: Array<ApprovalRequestTo>;
  comments?: Array<ApprovalComment>;
  private: boolean;
  createdAt: number;
  objectType: ApprovalObjectType;
}

export type CreateApprovalPayload = Pick<
  Approval,
  'private' | 'requestBy' | 'requestTo' | 'dueDate'
> & {
  comment?: Pick<ApprovalComment, 'content'>;
};

export type UpdateApprovalPayload = Pick<
  CreateApprovalPayload,
  'requestTo' | 'comment'
> & {
  approvalId: number;
};
